import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import React, { useEffect, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap';
import { changeRepairProductStatus, GenerateisStoreToMainStoreRepairChallan, generateRepairBag, GenerateRepairChallan, getRepairProductBagList, GetRepairProductsList, getRepairReceipt } from '../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import notistack from 'modules/core/notistack';
import PdfViewerModal from './PdfViewerModal';
import { apiClient } from 'helpers/api_helper';
import { formatDateToIST } from 'helpers/dateFormat';
import { HasPermission } from 'Layout/Permissions/permissionsCache';

const repairStatusOptions = [
    "Received for Repair",
    "Repaired",
    "Dispatched to Store",
    "Dispatched"
] as const;

type RepairStatus = typeof repairStatusOptions[number];

const statusOrderMap: Record<RepairStatus, number> = {
    "Received for Repair": 0,
    "Repaired": 1,
    "Dispatched to Store": 2,
    "Dispatched": 3,
};


const RepairProductBagList = () => {
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const [pendingChanges, setPendingChanges] = useState<{ [key: string]: string }>({});


    const [gridData, setGridData] = useState<{ data: any[]; totalCount: number }>({
        data: [],
        totalCount: 0,
    });
    const getRepairProductBagListProducts = async () => {
        try {
            const response = await getRepairProductBagList();
            setGridData({
                data: response.data,
                totalCount: response.data.length,
            })
        } catch (error: any) {
            notistack.error(error.message)
            setGridData({
                data: [],
                totalCount: 0,
            })
        }
    }

    useEffect(() => {
        getRepairProductBagListProducts()
    }, [])

    const refreshDataGrid = async () => {
        await getRepairProductBagListProducts();
        setRefreshKey(prev => prev + 1);
    };

    const handleRepairReceipt = async (data: any) => {
        try {
            setShowPdfModal(true)
            const response = await GenerateisStoreToMainStoreRepairChallan(data)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const handleRepairReceipt1 = async (data: any) => {
        try {
            setShowPdfModal(true)
            const response = await GenerateRepairChallan(data)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const [showRepairProductModal, setShowRepairProductModal] = useState(false)
    const [showProductData, setShowProductData] = useState<any[]>([])
    const [showRepairProductSubModal, setShowRepairProductSubModal] = useState(false)
    const [showProductSubData, setShowProductSubData] = useState<any[]>([])
    const [hideDropDown, setHideDropDown] = useState(false)
    const handleRepairBagProduct = async (id: any) => {
        try {
            setShowRepairProductModal(true)
            const response = await apiClient.get(`/api/v1/Repair/GetRepairWorkBagProductListByBagId?bagId=${id}`)
            setShowProductData(response.data)
            // if (!response.data) {
            //     notistack.notifyFromApi(response)
            // }
        } catch (error: any) {
            notistack.notifyFromApi(error.message)
        }
    }


    const reloadDataSource = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleRepairIdProduct = async (id: any) => {
        try {
            setShowRepairProductModal(false)
            setShowRepairProductSubModal(true)
            const response = await apiClient.get(`/api/v1/Repair/GetRepairWorkProductDetailsById?repairItemId=${id}`)
            setShowProductSubData(response.data)
            // if (!response.data) {
            //     notistack.notifyFromApi(response)
            // }
        } catch (error: any) {
            notistack.notifyFromApi(error.message)
        }
    }

    const [selectedId, setSelectedId] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState('')

    const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>, id: any) => {
        const selectedStatus = e.target.value;
        setPendingChanges(prev => ({
            ...prev,
            [id]: selectedStatus
        }));
        setSelectedId(id)
        setSelectedStatus(selectedStatus)
    };

    const handleSave = async (rowId: any) => {
        try {
            const statusToSave = pendingChanges[rowId];
            if (!statusToSave) return;

            const payload = {
                BagId: rowId,
                Status: statusToSave
            }
            const response = await changeRepairProductStatus(payload)
            if (rowId == 2) {

                setHideDropDown(true)
            }
            if (response.status == 200) {
                // console.log(response)
                notistack.notifyFromApi(response)

                setPendingChanges(prev => {
                    const updated = { ...prev };
                    delete updated[rowId];
                    return updated;
                });

                refreshDataGrid()
            }
        } catch (error: any) {
            notistack.error(error.message)
        }
    }



    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Repair Bag List</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission("RepairWork.Read") &&
                                <DataGrid
                                    dataSource={gridData.data}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    columnAutoWidth
                                    key={refreshKey}
                                    repaintChangesOnly={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />

                                    <Summary>
                                        <TotalItem
                                        // column="bagNo"
                                        // summaryType="count"
                                        // displayFormat="Total: {0} Bags"
                                        />
                                    </Summary>

                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />
                                    <Column
                                        caption="Action"
                                        width={200}
                                        allowFiltering={false}
                                        cssClass="text-center"
                                        cellRender={({ data }) => {
                                            const rawStatus = data.status;
                                            return <div className="d-flex gap-2">
                                                {HasPermission("RepairWork.Write") &&
                                                    <>
                                                        <button
                                                            className='btn btn-sm action-btn view-btn'
                                                            onClick={() => handleRepairBagProduct(data.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faEye} className='ml-2' />
                                                        </button>
                                                        <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={() => handleRepairReceipt(data.id)}>
                                                            <FontAwesomeIcon icon={faFilePdf} className="text-danger" />
                                                        </button>

                                                        {rawStatus == "Dispatched" ? <div style={{ visibility: 'hidden' }}>hiiiii</div> : <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={() => handleRepairReceipt1(data.id)}>
                                                            <FontAwesomeIcon icon={faFilePdf} className='text-black' />
                                                        </button>}
                                                    </>
                                                }
                                            </div>
                                        }}
                                    />
                                    <Column dataField="bagNo" caption="BagNo." />
                                    <Column dataField="id" visible={false} sortOrder="desc" allowFiltering={false} />
                                    <Column width={200} dataField="createdOn" caption="Created On" dataType="datetime" calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)} />
                                    <Column dataField="fromStore" caption="From Store" />
                                    <Column dataField="toStore" caption="To Store" />
                                    <Column dataField="status" caption="Current Status" />

                                    <Column
                                        caption="Change Status"
                                        width={220}
                                        allowFiltering={false}
                                        cssClass="text-center"
                                        cellRender={({ data }) => {
                                            const rawStatus = data.status;
                                            const normalizedStatus = rawStatus === "Dispatched" ? "Dispatched to Store" : rawStatus;
                                            const currentStatus = normalizedStatus as RepairStatus;

                                            const isEditMode = localStorage.getItem('mayavePurityEdit') === 'true';
                                            const currentValue = statusOrderMap[currentStatus] ?? -1;

                                            const shouldShowEditableDropdown = isEditMode && (
                                                ["Received for Repair", "Repaired", "Dispatched to Store"].includes(currentStatus) ||
                                                rawStatus === "Dispatched"
                                            );

                                            const shouldShowReadyToPickupText = !isEditMode && currentStatus === "Dispatched to Store";

                                            return (
                                                <div className="d-flex align-items-center justify-content-center gap-2">

                                                    <>
                                                        {rawStatus === "Dispatched to Store" ? null : <> {shouldShowEditableDropdown && (
                                                            <>
                                                                <select
                                                                    className="form-select form-select-sm w-auto"
                                                                    value={pendingChanges[data.id] ?? ""}
                                                                    onChange={(e) => handleStatusChange(e, data.id)}
                                                                >
                                                                    <option value="">Select Status</option>
                                                                    {repairStatusOptions
                                                                        .filter((status) => {
                                                                            if (status === "Dispatched") return false;
                                                                            if (rawStatus === "Dispatched") {
                                                                                return ["Received for Repair", "Repaired", "Dispatched to Store"].includes(status);
                                                                            }
                                                                            return statusOrderMap[status] > currentValue;
                                                                        })
                                                                        .map((status) => (
                                                                            <option key={status} value={status}>{status}</option>
                                                                        ))}
                                                                </select>

                                                                <button
                                                                    className="btn submit-btn"
                                                                    onClick={() => handleSave(data.id)}
                                                                    disabled={!pendingChanges[data.id]}
                                                                >
                                                                    Save
                                                                </button>
                                                            </>
                                                        )}</>}</>


                                                    {rawStatus === "Dispatched to Store" && shouldShowReadyToPickupText && (
                                                        <>
                                                            <select
                                                                className="form-select form-select-sm w-auto"
                                                                value={pendingChanges[data.id] ?? ""}
                                                                onChange={(e) => handleStatusChange(e, data.id)}
                                                            >
                                                                <option value="">Select Status</option>
                                                                <option value="Ready to Pick Up">Ready to Pick Up</option>
                                                            </select>

                                                            <button
                                                                className="btn submit-btn"
                                                                onClick={() => handleSave(data.id)}
                                                                disabled={!pendingChanges[data.id]}
                                                            >
                                                                Save
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />



                                </DataGrid>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>


            {/* details modal */}
            <Modal
                show={showRepairProductModal}
                onHide={() => setShowRepairProductModal(false)}
                size="lg"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Repair bag details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DataGrid
                        dataSource={showProductData}
                        keyExpr="id"
                        showBorders={true}
                        showRowLines={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                    >

                        <Scrolling
                            mode='standard'
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />
                        <Column dataField="repairNo" caption="Repair No" />
                        <Column dataField="igiNo" caption="IGI No" />
                        <Column dataField="huidNo" caption="HUID No" />
                        <Column dataField="categoryName" caption="Category" />
                        <Column dataField="styleNo" caption="Style No" />
                        <Column dataField="diamondQty" caption="Diamond Qty" dataType="number" />
                        <Column dataField="grossWt" caption="Gross Wt" dataType="number" format={{ type: 'fixedPoint', precision: 3 }} />
                        <Column dataField="repairDate" caption="Repair Date" dataType="date" format="dd/MM/yyyy" />
                        <Column dataField="customerName" caption="Customer Name" />
                        <Column dataField="productAmount" caption="Product Amt" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                        <Column dataField="totalAmount" caption="Total Amt" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                        <Column dataField="dueAmount" caption="Due Amt" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                        <Column dataField="status" caption="Status" />
                        <Column
                            width={80}
                            allowFiltering={false}
                            cssClass="text-center"
                            caption='Reason'
                            cellRender={({ data }) => (
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                    <button
                                        className='btn btn-sm action-btn view-btn'
                                        onClick={() => handleRepairIdProduct(data.id)}
                                    >
                                        <FontAwesomeIcon icon={faEye} className='ml-2' />
                                    </button>
                                </div>
                            )}
                        />
                        {/* <Summary>
                            <TotalItem
                                column="productAmount"
                                summaryType="sum"
                                valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                displayFormat="Total: {0}"
                            />
                            <TotalItem
                                column="totalAmount"
                                summaryType="sum"
                                valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                displayFormat="Total: {0}"
                            />
                            <TotalItem
                                column="dueAmount"
                                summaryType="sum"
                                valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                displayFormat="Total: {0}"
                            />
                        </Summary> */}
                    </DataGrid>
                </Modal.Body>
            </Modal>


            {/* subDetails modal */}
            <Modal
                show={showRepairProductSubModal}
                onHide={() => setShowRepairProductSubModal(false)}
                size="lg"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Repair Reasons</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DataGrid
                        dataSource={showProductSubData}
                        keyExpr="id"
                        showBorders={true}
                        showRowLines={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                    >
                        <Scrolling
                            mode='standard'
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />
                        <Column dataField="repairWork" caption="Repair Work" />
                        <Column dataField="qtyOrWt" caption="Qty/Wt" dataType="number" format={{ type: 'fixedPoint', precision: 3 }} />
                        <Column dataField="repairAmount" caption="Repair Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                        <Column dataField="remark" caption="Remark" />
                        <Column dataField="leadTimeInDays" caption="Lead Time (Days)" dataType="number" />
                        <Column
                            dataField="deliveryDate"
                            caption="Delivery Date"
                            dataType="date"
                            format="dd/MM/yyyy"
                        />
                    </DataGrid>
                </Modal.Body>
            </Modal>

            <PdfViewerModal
                visible={showPdfModal}
                base64Data={pdfData}
                onClose={() => {
                    setShowPdfModal(false);
                    setPdfData(null);
                }}
                title={`Delivery Challan`}
            />
        </>
    )
}

export default RepairProductBagList